import { gql } from "@apollo/client";

export const CREATE_AI_ADDON_MUTATION = gql`
  mutation CreateAIAddon($input: CreateAIAddonInput!) {
    createAIAddon(input: $input) {
      id
      name
      description
      pricingType
      amount
      currency
      interval
      intervalCount
      creditPoolSize
      stripePriceId
      stripeProductId
      eligiblePlanIds
      active
      type
      credits
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const UPDATE_AI_ADDON_MUTATION = gql`
  mutation UpdateAIAddon($input: UpdateAIAddonInput!) {
    updateAIAddon(input: $input) {
      id
      name
      description
      pricingType
      amount
      currency
      interval
      intervalCount
      creditPoolSize
      credits
      stripeProductId
      stripePriceId
      eligiblePlanIds
      active
      type
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const DELETE_AI_ADDON_MUTATION = gql`
  mutation DeleteAIAddon($input: DeleteAIAddonInput!) {
    deleteAIAddon(input: $input) {
      success
      message
    }
  }
`;

// Create Manufacturer Mutation
